import React from "react";
import asPage from "components/core/as-page";
import Breadcrumbs from "components/core/breadcrumbs";
import Header from "components/core/header";
import HeaderBanner from "components/core/header-banner";
import Layout from "components/core/layout";
import Link from "components/elements/link";
import SVG from "components/elements/svg";

const Testimonials = () => {
  return (
    <Layout className="testimonials" title="Testimonials">
      <Header>
        <HeaderBanner
          title="Testimonials"
          icon="testimonials"
          background="/static/images/header-testimonials.jpg"
        />
      </Header>

      <Breadcrumbs>
        <Breadcrumbs.Item url="testimonials" title="Testimonials" />
      </Breadcrumbs>

      <section className="how-it-works__content">
        <div className="container">
          <h2 className="section-heading center">
            Read what our customers have to say:
          </h2>
          <div className="row">
            <div className="col-md-4 col-xs-12">
              <div className="box" role="button" tabIndex={0}>
                <SVG src="reasons-2" className="icon" />

                <div className="content">
                  <h3 className="title">Buyers' testimonials</h3>
                </div>

                <Link to="testimonials/buyer" />
              </div>
            </div>
            <div className="col-md-4 col-xs-12">
              <div className="box" role="button" tabIndex={0}>
                <SVG src="sold" className="icon" />

                <div className="content">
                  <h3 className="title">Sellers' testimonials</h3>
                </div>

                <Link to="testimonials/seller" />
              </div>
            </div>
            <div className="col-md-4 col-xs-12">
              <div className="box" role="button" tabIndex={0}>
                <SVG src="solicitor-thin" className="icon" />

                <div className="content">
                  <h3 className="title">Solicitors' testimonials</h3>
                </div>

                <Link to="testimonials/solicitor" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default asPage(Testimonials);
